import XLSX from 'xlsx'
import moment from 'moment'

export function handleFormat (obj) {
  const result = []
  for (const key in obj) {
    result[key] = obj[key]
  }
  return result
}
export function transToUint8Array (str) {
  var a = str.substr(5, 21)
  var len = a.length
  var arr = []
  for (let i = 0; i < len; i++) {
    arr.push(a.charCodeAt(i))
  }
  var tmpUint8Array = new Uint8Array(arr)
  return tmpUint8Array
}
export function listToTree (list) {
  var getTree = (routes, pid = 0) => {
    const result = []
    let temp
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].pid === pid) {
        const current = { ...routes[i] }
        temp = getTree(routes, routes[i].id)
        if (temp.length > 0) {
          current.children = temp
        }
        result.push(current)
      }
    }
    return result
  }
  return getTree(list)
}

export function importExcel (event, element, callback) {
  if (!event.target.files) return
  var f = event.target.files[0]
  var reader = new FileReader()
  var excelJson
  reader.onload = function (e) {
    var data = e.target.result
    var wb = XLSX.read(data, { type: 'binary' })
    excelJson = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
    var excelXLSX = wb.Sheets[wb.SheetNames[0]]
    document.getElementById(element).reset()
    callback(excelJson, excelXLSX)
  }
  reader.readAsBinaryString(f)
}

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

export function isEmail (value) {
  const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
  return regex.test(value)
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

/**
 * 清理空值，对象
 * @param children
 * @returns {*[]}
 */
export function filterEmpty (children = []) {
  return children.filter(c => c.tag || (c.text && c.text.trim() !== ''))
}

/**
 * 获取字符串长度，英文字符 长度1，中文字符长度2
 * @param {*} str
 */
export const getStrFullLength = (str = '') =>
  str.split('').reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0)
    if (charCode >= 0 && charCode <= 128) {
      return pre + 1
    }
    return pre + 2
  }, 0)

/**
 * 截取字符串，根据 maxLength 截取后返回
 * @param {*} str
 * @param {*} maxLength
 */
export const cutStrByFullLength = (str = '', maxLength) => {
  let showLength = 0
  return str.split('').reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0)
    if (charCode >= 0 && charCode <= 128) {
      showLength += 1
    } else {
      showLength += 2
    }
    if (showLength <= maxLength) {
      return pre + cur
    }
    return pre
  }, '')
}

export function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('loadend', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export function getRandom (num) {
  const aryWord = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
  ]
  let randomStr = ''
  for (let i = 0; i < num; i++) {
    randomStr += aryWord[Math.floor(aryWord.length * Math.random())]
  }
  return randomStr
}

export function pushHistory () {
  history.pushState({}, null, window.location.href)
}

var orignalSetItem = localStorage.setItem
localStorage.setItem = function (key, newValue) {
  var setItemEvent = new Event('setItemEvent')
  setItemEvent.key = key
  window.dispatchEvent(setItemEvent)
  orignalSetItem.apply(this, arguments)
}
export function setLocalStorage (name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}
export function getLocalStorage (name) {
  return JSON.parse(localStorage.getItem(name))
}

export function clearLocalStorage (name) {
  localStorage.removeItem(name)
}
// 手机号掩码  中间4位数字以*替代
export function phoneAddCode (val) {
  var reg = /^(\d{3})\d{4}(\d{4})$/
  return val.replace(reg, '$1****$2')
}
// 身份证号掩码  显示前6位和后4位，中间的数字用*替代
export function idcardAddCode (val) {
  var reg = /^(\d{6})\d{8}(\d{4})$/
  return val.replace(reg, '$1**********$2')
}
// 邮箱掩码 1、如账号为邮箱格式，形如账号+@+域名。账号取前3位显示，后面不管多少个字符都用三个*替代，@和域名明文显示。2、如账号为手机号格式，参考上述手机号掩码规则
export function alipayaccountAddCode (val) {
  if (val.indexOf('@') > 0) {
    var reg = val.split('@')[0].substring(0, 3) + '***@' + val.split('@')[1]
    return reg
  } else {
    var reg1 = /^(\d{3})\d{4}(\d{4})$/
    return val.replace(reg1, '$1****$2')
  }
}
// 姓名打码
export function usernameAddCode (val) {
  var reg = new Array(val.length).join('*') + val.substr(-1)
  return reg
}
export function timeFormat (val) {
  return moment.unix(val).calendar(null, {
    sameDay: function (now) {
      if (now - this < 60 * 60 * 1000) {
        if (now - this < 60 * 1000) {
          return '[刚刚]'
        } else {
          return Math.floor((now - this) / 1000 / 60) + '[分钟前]'
        }
      } else {
        return '[今天] HH:mm'
      }
      /* ... */
    },
    lastWeek: 'MM[月]DD[日] HH:mm',
    lastDay: '[昨天] HH:mm',
    sameElse: function (now) {
      if (now.year() - this.year() < 1) {
        return 'MM[月]DD[日] HH:mm'
      } else {
        return 'YYYY[年]MM[月]DD[日] HH:mm'
      }
    }
  })
}

export function dataURLtoFile (dataurl, filename) { // 将base64转换为文件
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

// 将base64转换为blob
export function dataURLtoBlobs (dataurl) {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?);/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}
// 将blob转换为file
export function blobToFile (theBlob, fileName) {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

export function showText (text, numSub) {
  if (text == null) {
    return ''
  }
  if (text.length > numSub) {
    return text.substring(0, numSub - 1) + '...'
  }
  return text
}

// 节流
export function _throttle (fn, interval) {
  var last
  var timer
  interval = interval || 200
  return function () {
    var th = this
    var args = arguments
    var now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        last = now
        fn.apply(th, args)
      }, interval)
    } else {
      last = now
      fn.apply(th, args)
    }
  }
}

// 防抖

export function _debounce (fn, delay) {
  console.log(fn)
  delay = delay || 200
  var timer
  return function () {
    var th = this
    var args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(function () {
      timer = null
      fn.apply(th, args)
    }, delay)
  }
}

export const ScrollTop = (dom = document.body, number = 0, time) => {
  if (!time) {
    dom.scrollTop = number
    return number
  }
  const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
  let spacingInex = time / spacingTime // 计算循环的次数
  let nowTop = dom.scrollTop // 获取当前滚动条位置
  const everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
  const scrollTimer = setInterval(() => {
    if (spacingInex > 0) {
      spacingInex--
      ScrollTop(dom, nowTop += everTop)
    } else {
      clearInterval(scrollTimer) // 清除计时器
    }
  }, spacingTime)
}

/**
* HSL颜色值转换为RGB.
* 换算公式改编自 http://en.wikipedia.org/wiki/HSL_color_space.
* h, s, 和 l 设定在 [0, 1] 之间
* 返回的 r, g, 和 b 在 [0, 255]之间
*
* @param   Number  h       色相
* @param   Number  s       饱和度
* @param   Number  l       亮度
* @return  Array           RGB色值数值
*/
export function hslToRgb (h, s, l) {
  var r, g, b

  if (s == 0) {
    r = g = b = l // achromatic
  } else {
    var hue2rgb = function hue2rgb (p, q, t) {
      if (t < 0) t += 1
      if (t > 1) t -= 1
      if (t < 1 / 6) return p + (q - p) * 6 * t
      if (t < 1 / 2) return q
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
      return p
    }

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s
    var p = 2 * l - q
    r = hue2rgb(p, q, h + 1 / 3)
    g = hue2rgb(p, q, h)
    b = hue2rgb(p, q, h - 1 / 3)
  }

  return [r, g, b]
}
